import { render, staticRenderFns } from "./UserShow.vue?vue&type=template&id=579f8870&"
import script from "./UserShow.vue?vue&type=script&lang=js&"
export * from "./UserShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports